<template>
  <div class="not-found-page">
    <div class="centered">
      <h1>403</h1>
      <p>
        You are not authorized to access
        <span class="bold">{{ resourceName }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Unauthorized401",
  props: {
    resourceName: {
      type: String,
      default: "this resource.",
    },
  },
};
</script>
